<template>
  <div>
    <div style="background-color: #000; width: 100%;">
      <player></player>
    </div>
    <div style="background-color: rgb(74, 147, 174); width: 100%">
      <v-container>
        <v-layout row wrap>
          <v-flex md8>
            <h3 style="color:#fff;">Congreso de Urgencias</h3>
          </v-flex>
          <v-flex md4>
            <iframe src='https://minnit.chat/clinicadelnorte?embed&nickname=' style='border:none;width:90%;height:500px;' allowTransparency='true'></iframe>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>
<script>
  import Player from '@/components/Player.vue';
  export default {
    name: 'Evento',
    components: {
      Player
    }
  }
</script>